import React from 'react';
import {Outlet} from "react-router-dom";
import {useAuth} from "react-oidc-context";

export function PrivateRoute() {

    const auth = useAuth();

    function ExternalRedirect() {
        auth.signinRedirect().catch(error => console.error(error))
        return null;
    }

    return (auth.isAuthenticated && auth.user?.access_token) ? <Outlet/> : <ExternalRedirect/>
}